const actionTypes = { CONFIRM_RETURN_ORDER: 'CONFIRM_RETURN_ORDER' };

module.exports = actionTypes;
